import { Injectable, Type } from '@angular/core';
import { Subject } from 'rxjs';

export interface ModalConfig {
	component: Type<any>;
	props?: Record<string, any>;
	cssClass?: string;
}

@Injectable({ providedIn: 'root' })
export class ModalService {
	private modalSubject = new Subject<ModalConfig | null>();
	modal$ = this.modalSubject.asObservable();

	open(config: ModalConfig) {
		this.modalSubject.next(config);
	}

	close() {
		this.modalSubject.next(null);
	}
}
